<template>
  <div v-if="!reloading  && !blockNewSleeker">
    <b-modal v-model="showRemoveUploadModal" hide-footer>
      Tem certeza de que quer excluir esta imagem?
      <b-row>
        <b-col>
          <b-button class="mt-3 bg-success" block @click="showRemoveUploadModal = false">Cancelar</b-button>
        </b-col>
        <b-col>
          <b-button class="mt-3 bg-danger" block @click="removeUpload(uploadToRemove)">Excluir</b-button>
        </b-col>
      </b-row>
      <br/>
      <br/>
    </b-modal>
    <div class="content-wrapper m-t m-b">
      <div class="list-wraper">
        <b-row style="margin-bottom: 20px; margin-top: 20px;">
          <b-col v-show="!choosingElement" offset-sm="3" sm="2">
              <div v-show="loaded">
              <button
                v-b-tooltip.hover
                :disabled="changingTextColor || changingTextFont"
                title="Adiciona uma nova caixa de texto"
                @click="addText"
                style="width: 80%; margin-left: 10%; margin-bottom: 10px;"
                class="btn btn-block btn-outline-primary bg-info m-t"
                type="button"
              >
                <i class="fa fa-font"></i> &nbsp; Adicionar Texto
              </button>
            </div>
          </b-col>
          <b-col v-show="!choosingElement" sm="2">
              <div v-show="loaded">
                <button
                  v-b-tooltip.hover
                  v-if="template && template.frame"
                  :disabled="!enableSendToBackground"
                  v-bind:title="'Adiciona uma nova caixa de texto'"
                  @click="sendToBackground"
                  style="width: 80%; margin-left: 10%; margin-bottom: 10px;"
                  class="btn btn-block btn-outline-primary bg-info m-t"
                  type="button"
                >
                  <i class="fa fa-image"></i> &nbsp; Usar como plano de fundo
                </button>
                <button
                  v-b-tooltip.hover
                  title="O item selecionado será deletado"
                  :disabled="changingTextColor || changingTextFont"
                  @click="handleDelete"
                  style="width: 80%; margin-left: 10%; margin-bottom: 10px;"
                  class="btn btn-block btn-outline-danger bg-danger m-t"
                  type="button"
                >
                  <i class="fa fa-trash"></i> &nbsp; Deletar Item
                </button>
                 </div>
          </b-col>
          <b-col v-show="!choosingElement" sm="2">
              <div v-show="loaded">
                <spinner id="loadingDiv" class="m-t" v-if="disableSaveButton == true"></spinner>
                <button
                  v-b-tooltip.hover
                  v-bind:title="'Baixar ou Salvar para usar depois'"
                  @click="saveTemplate"
                  v-show="!disableSaveButton"
                  class="btn btn-block btn-outline-success bg-green m-t"
                  type="button"
                  style="color: white; width: 80%; margin-left: 10%; margin-bottom: 10px;"
                >
                  <i class="fa fa-save"></i>
                  &nbsp; Finalizar
                </button>

                <!-- https://api.whatsapp.com/send?phone=5581992818077&text=diego -->
              </div>
              
            </b-col>
        </b-row>
        <b-row  v-bind:class="{'margin-mobile' : isMobileScreen}">
          <!--<b-col cols="2">
            <div class="card-body bg-white" style="padding: 10px !important;">
              <div class="h1 text-muted text-center mb-4">
                <i class="fa fa-question"></i>
              </div>
              <div class="text-value"></div>
              <small class="text-muted font-weight-bold" v-if="advancedEdition == false">
                1. Importe sua imagem
                <br />2. Clique na imagem para adicionar ao template
                <br />3. Ajuste-a como preferir!
              </small>
              <small class="text-muted font-weight-bold" v-if="advancedEdition == true">
                1. Importe sua imagem
                <br />2. Clique na imagem para adicionar ao template
                <br />3. Ajuste-a como preferir!
                <br />4. Clique nos textos para alterar o conteÃºdo ou redimensionar
              </small>
              <div class="card-body bg-white" style="padding: 10px !important;">
                <div class="h1 text-danger text-center mb-4">
                  <i class="fa fa-warning"></i>
                </div>
                <small
                  class="text-muted font-weight-bold"
                >Não é possível arrastar imagens para o template</small>
              </div>
            </div>
          </b-col>-->

          <b-col sm="2" offset-sm="5" class="text-center">
            <spinner id="loadingDiv" class="m-t" v-if="loaded == false"></spinner>
            <b-row v-show="!changingTextColor && !changingTextFont" style="margin-bottom: 20px;" class="text-center">
              <b-col class="text-center">
                <div v-bind:class="{'center-component': !this.bigEditorCanva, 'center-component-big': this.bigEditorCanva}">
                  <vue-fabric
                    v-if="(this.template || this.templateId == 'new') && (this.heightAndWidth && this.heightAndWidth.height && this.heightAndWidth.width)"
                    v-show="!choosingElement"
                    crossorigin="Anonymous"
                    ref="canvas"
                    :width="this.heightAndWidth.width"
                    :height="this.heightAndWidth.height"
                    :background="templateId == 'new' || templateId == 'new-story'? '#ffffff' : 'transparent'"
                    :backgroundImage="backgroundImage"
                    v-on:loadedBackground="loaded = true"
                    @selection:created="selected"
                    @selection:updated="selected"
                    @selection:cleared="clearedSelection"
                    @attachment:added="attachmentLoaded"
                    @object:moving="moving"
                    @object:modified="modified"
                  ></vue-fabric>
                </div>
              </b-col>
            </b-row>
            <div class="card-body" style="height: 350px; overflow: auto;" v-if="changingTextColor">
              <b-row v-if="changingTextColor">
                <b-col lg="12" class="text-center">
                  <chrome-picker
                    v-model="selectedColor"
                    style="margin-left: auto; margin-right: auto;"
                  />
                </b-col>

                <b-col lg="4" offset-lg="2">
                  <button
                    v-b-tooltip.hover
                    title="Alterar cor"
                    @click="changeTextColor()"
                    class="btn btn-block btn-outline-primary bg-success m-t"
                    type="button"
                  >
                    <i class="fa fa-paint-brush"></i> &nbsp; 
                  </button>
                </b-col>
                <b-col lg="4">
                  <button
                    v-b-tooltip.hover
                    title="Voltar sem alterar"
                    @click="changingTextColor = false"
                    class="btn btn-block btn-outline-primary bg-danger m-t"
                    style="width: 100%;"
                    type="button"
                  >
                    <i class="fa fa-close"></i> &nbsp; 
                  </button>
                </b-col>
              </b-row>
            </div>
            <div class="card-body" style="height: 350px; overflow: auto;" v-if="changingTextFont">
              <b-row>
                <b-col sm="12">
                  <b-list-group>
                    <b-list-group-item>
                      <button
                        v-b-tooltip.hover
                        title="Voltar sem alterar"
                        @click="changingTextFont = false"
                        class="btn btn-danger"
                        style="width: 100%;"
                        type="button"
                      >Voltar</button>
                    </b-list-group-item>
                    <b-list-group-item v-for="font in fontList" v-bind:key="font">
                      <button
                        v-b-tooltip.hover
                        title="Alterar fonte"
                        @click="changeTextFont(font)"
                        class="btn btn-block"
                        type="button"
                        v-bind:style="'font-family: ' + font"
                      >{{font}}</button>
                    </b-list-group-item>
                    <b-list-group-item>
                      <button
                        v-b-tooltip.hover
                        title="Voltar sem alterar"
                        @click="changingTextFont = false"
                        class="btn btn-danger"
                        style="width: 100%;"
                        type="button"
                      >Voltar</button>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" v-if="showTextEdit">
            <div style="margin-top: 130px;" v-if="story == true"></div>
            <div style="margin-top: 10px;" v-if="story == false"></div>
            <div class="card" style="margin-bottom: unset !important;">
              <div
                class="card-body"
                style="min-height: 75px; overflow: auto;"
                v-if="!changingTextColor && !changingTextFont"
              >
                <b-row>
                  <b-col sm="2">
                    <button
                      @click="changingTextColor = true"
                      class="btn btn-block btn-outline-primary bg-info"
                      type="button"
                    >
                      <i class="fa fa-paint-brush"></i> &nbsp;Cor
                    </button>
                  </b-col>
                  <b-col sm="2">
                    <button
                      @click="changingTextFont = true"
                      class="btn btn-block btn-outline-primary bg-info"
                      type="button"
                    >
                      <i class="fa fa-font"></i> &nbsp;Fonte
                    </button>
                  </b-col>
                  <b-col sm="2">
                    <button
                      @click="changeTextWeight()"
                      class="btn btn-block btn-outline-primary bg-info"
                      type="button"
                    >
                      <i class="fa fa-bold"></i> &nbsp;Negrito
                    </button>
                  </b-col>
                  <b-col sm="2">
                    <button
                      @click="changeTextStyle()"
                      class="btn btn-block btn-outline-primary bg-info"
                      type="button"
                    >
                      <i class="fa fa-italic"></i> &nbsp;Itálico
                    </button>
                  </b-col>
                  <b-col sm="4">
                    <button
                      @click="duplicateText()"
                      class="btn btn-block btn-outline-primary bg-info"
                      type="button"
                    >
                      <i class="fa fa-copy"></i> &nbsp; Duplicar Texto Selecionado
                    </button>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="m-t" v-show="!showTextEdit" v-bind:class="{'margin-mobile' : isMobileScreen}">
          <b-col class="text-center" sm="2" offset-sm="5">
            <b-row class="text-center">
              <b-col class="text-center">
                <dropzone style="margin-left:10px; width: 170px; heigth: 100% !important;" v-on:uploadComplete="loadUploads" />
              </b-col>
            </b-row>
            <spinner
              id="loadingDiv"
              class="m-t"
              v-if="loadingAttachment == true"
              style="margin-left: 40px !important;"
            ></spinner>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import VueImageModel from "./ImageModel.vue";
import Dropzone from "../CustomDropzone";
import service from "../../service";
import { isMobile } from "mobile-device-detect";
import Spinner from "../Spinner";
import Config from "../../config";
import { constants } from "fs";
import { setTimeout } from "timers";
import { Chrome } from "vue-color";
import ColorSlider from '../ColorSlider.vue';

export default {
  name: "editor",
  components: {
    VueImageModel,
    dropzone: Dropzone,
    Spinner,
    ColorSlider,
    "chrome-picker": Chrome
  },
  props: {
    json: undefined,
    creation: undefined,
    customSavingUrl: undefined
  },
  data() {
    return {
      showRemoveUploadModal: false,
      uploadToRemove: undefined,
      templateId: this.$route.params.id,
      template: undefined,
      userAddedUniques: "",
      psd: false,
      imgUrl: "",
      list: [],
      isMobileScreen: isMobile,
      loading: false,
      jsonCopy: undefined,
      jsonObject: undefined,
      test1: true,
      test2: false,
      advancedEdition: false,
      backgroundImage: "",
      loaded: false,
      loadingAttachment: false,
      actionList: undefined,
      showImportImage: false,
      enableSendToBackground: false,
      currentItem: null,
      showSave: false,
      showTextEdit: false,
      showTrash: false,
      selectedIndex: -1,
      loadingJson: false,
      temporaryText: "",
      selectedColor: "#ffffff",
      changingTextColor: false,
      changingTextFont: false,
      background: "transparent",
      fontList: [
        
      ],
      updatingTextProperties: false,
      story: false,
      preventLocking: false,
      reloading: false,
      forceStory: false,
      disableSaveButton: false,
      lastJson: [],
      baseImageLoaded: false,
      preventUndo: false,
      lineSize: 0.8,
      blockNewSleeker: false,
      choosingElement: false,
      choosingElementVersion: false,
      elements: [],
      selectedElement: undefined,
      customEditorSize: "",
      heightAndWidth: {},
      imgList: []
    };
  },
  computed: {
    bigEditorCanva() {
      if (this.template && this.template.bigEditorCanva) {
        return true;
      }
      return  false;
    },
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    initialMultiplier: function() {
      let baseWidth = (this.psd) ? (this.json.objects[0].width) : 1080;
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    finalMultiplier: function() {
      let baseWidth = 1080;
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    finalImageMultiplier: function() {
      let baseWidth = this.story ? 1080 : 1200;

      if (this.template && this.template.customEditorWidth) {
        baseWidth = this.template.customEditorWidth;
      }
      
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    isInstagramBrowser: function() {
      var str = navigator.userAgent;
      
      var i = str.indexOf("Instagram");
      if (i <= -1) {
        return false;
      }
      return true;
    }
  },
  created() {
    service.getFonts().then(result => {
      this.fontList = result.fonts;
    });

    service.getElements().then(result => {
      this.elements = result.elements;
    });
  },
  mounted() {
    this.reload();

    if (this.$route.query.firstEdition) {
      fbq('trackCustom', 'FirstEdition');
    }
  },
  methods: {
    loadUploads(info) {
      this.handleAdd(info.fileInfo.imageUrl);
    },
    changeColor(value) {
      console.log(value);
      this.$refs.canvas.applyFilterToImage(1, value);
    },
    hideElements() {
      this.choosingElement = false;
      this.choosingElementVersion = false;
      this.selectedElement = undefined;
    },
    openElements() {
      this.choosingElement = true;
    },
    sendToBackground() {
      this.$refs.canvas.toBottomLayer();
      this.$refs.canvas.toLastLayer();
    },
    handleCompleteLoad() {
      if (this.baseImageLoaded == false) {

      } else {
        
      }
    },
    reload(force) {
      this.reloading = false;
      this.loaded = false;

      if (force == true) {
        this.loaded = true;
      }
      
      if (this.templateId == "new-story") {
        this.story = true;
        this.loaded = true;
        this.loadingJson = false;
      } else if (this.templateId == "new") { 
        if (!this.creation) {
          this.blockNewSleeker = true;
          return;
        }

        this.calculateHeightAndWidth();

        if (this.json) {
          this.psd = true;
          this.jsonObject = this.json.objects;
          this.jsonCopy = this.calculateScale();
          this.loadJSON(this.jsonCopy, undefined,  undefined, true);
        } else {
          this.loadingJson = false;
          this.loaded = true;
          this.background = "#ffffff";
          //let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas.toJson())); //deepCopy
          //this.lastJson.push(copyItem);
        }
      } else {
        service.getTemplateById(this.templateId).then(
          response => {
            this.story = this.forceStory ? true : response.template.story;
            this.template = response.template;

            this.calculateHeightAndWidth();

            if (response.template.advancedEdition == true && response.template.json != null) {
              if (response.template.json.objects.length > 1) {
                this.advancedEdition = true;
                this.jsonObject = response.template.json.objects;
                this.backgroundColor = response.template.json.background;
                this.jsonCopy = this.calculateScale();
                this.loaded = true;

                this.loadJSON(this.jsonCopy, null, this.handleCompleteLoad);
              } else {
                this.setBackgroundImage(response.template.fullImage + "?" + Math.random());
                this.advancedEdition = false;
                //this.loaded = true;
                if (this.$refs.canvas) {
                  let copyItem = JSON.parse(
                    JSON.stringify(this.$refs.canvas.toJson())
                  ); //deepCopy
                  this.lastJson.push(copyItem);
                }
              }
            } else {
              this.setBackgroundImage(
                response.template.fullImage + "?" + Math.random()
              );
              this.advancedEdition = false;
              //this.loaded = true;
            }
          },
          () => {
            //this.loaded = true;
            this.loadingJson = false;
          }
        );
      }
    },
    calculateHeightAndWidth() {
      let baseHeight = (this.isMobileScreen) ? 320 : 360;
      let baseWidth = (this.isMobileScreen) ? 320 : 360;

      if (this.story) {
        baseHeight = (this.isMobileScreen) ? 320 : 480;
        baseWidth = (this.isMobileScreen) ? 180 : 270;
      }

      if (this.template && this.template.customEditorHeight && this.template.customEditorWidth) {
        let heightFactor = this.template.customEditorHeight / baseHeight;
        let widthFactor = this.template.customEditorWidth / baseWidth;
        let finalFactor = (widthFactor > heightFactor) ? widthFactor : heightFactor;
        let height = this.template.customEditorHeight / finalFactor;
        let width = this.template.customEditorWidth / finalFactor;
        
        this.heightAndWidth = { height: height, width: width };

        console.log("versao 1");
        console.log(this.heightAndWidth);
        
      } else {
        this.heightAndWidth = { height: baseHeight, width: baseWidth };

        console.log("versao 2");
        console.log(this.heightAndWidth);
      }
    },
    exportStory() {
      this.forceStory = true;
      this.reloading = true;
      this.reload();
    },
    unlockAll() {
      this.preventLocking = true;
      if (this.actionList) {
        this.loadJSON(this.actionList, true, () => {});
      }
    },
    setBackgroundImage(backgroundImage) {
      //this.loadingJson = true;
      if (!this.$refs.canvas) {
        setTimeout(() => {
          this.setBackgroundImage(backgroundImage);
        }, 100);
        return;
      }

      this.backgroundImage = backgroundImage;
      //this.loadingJson = false;
    },
    sendBackwards() {
      this.$refs.canvas.toNextLayer();
    },
    sendForward() {
      this.$refs.canvas.toLastLayer();
    },
    removeItem() {
      this.$refs.canvas.removeCurrentObj();
      this.showTrash = false;
      this.loadJSON(this.$refs.canvas.toJson());
    },
    resetControls() {
      this.loadJSON(this.$refs.canvas.toJson(), true);
    },
    changeTextWeight() {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas.toJson())); //deepCopy
      this.lastJson.push(copyItem);
      this.updatingTextProperties = true;
      this.changingTextColor = false;

      let newFontWeight = "bold";
      if (this.currentItem.fontWeight == "bold") {
        newFontWeight = "normal";
      }

      this.currentItem.fontWeight = newFontWeight;
      if (this.currentItem && this.currentItem.styles) {
        for (let style in this.currentItem.styles) {
          for (let styleItem in this.currentItem.styles[style]) {
            this.currentItem.styles[style][
              styleItem
            ].fontWeight = newFontWeight;
          }
        }
      }
      this.loadJSON(this.$refs.canvas.toJson(), null, () => {
        this.updatingTextProperties = false;
      });
    },
    changeTextStyle() {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas.toJson())); //deepCopy
      this.lastJson.push(copyItem);
      this.updatingTextProperties = true;
      this.changingTextColor = false;

      let newFontStyle = "italic";
      if (this.currentItem.fontStyle == "italic") {
        newFontStyle = "normal";
      }

      this.currentItem.fontStyle = newFontStyle;
      if (this.currentItem && this.currentItem.styles) {
        for (let style in this.currentItem.styles) {
          for (let styleItem in this.currentItem.styles[style]) {
            this.currentItem.styles[style][styleItem].fontStyle = newFontStyle;
          }
        }
      }
      this.loadJSON(this.$refs.canvas.toJson(), null, () => {
        this.updatingTextProperties = false;
      });
    },
    duplicateText() {
      let copyItem = JSON.parse(JSON.stringify(this.currentItem)); //deepCopy
      let json = this.$refs.canvas.toJson();
      json.objects.push(copyItem);

      this.loadJSON(json, null, () => {});
    },
    changeTextColor() {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas.toJson())); //deepCopy
      this.lastJson.push(copyItem);

      this.updatingTextProperties = true;
      this.changingTextColor = false;
      this.currentItem.fill = this.selectedColor.hex;
      if (this.currentItem && this.currentItem.styles) {
        for (let style in this.currentItem.styles) {
          for (let styleItem in this.currentItem.styles[style]) {
            this.currentItem.styles[style][styleItem].fill = this.selectedColor;
          }
        }
      }
      this.loadJSON(this.$refs.canvas.toJson(), null, () => {
        this.updatingTextProperties = false;
      });
    },
    changeTextFont(font) {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas.toJson())); //deepCopy
      this.lastJson.push(copyItem);

      this.updatingTextProperties = true;
      this.changingTextFont = false;
      this.currentItem.fontFamily = font;
      if (this.currentItem && this.currentItem.styles) {
        for (let style in this.currentItem.styles) {
          for (let styleItem in this.currentItem.styles[style]) {
            this.currentItem.styles[style][styleItem].fontFamily = font;
          }
        }
      }
      this.loadJSON(this.$refs.canvas.toJson(), null, () => {
        this.updatingTextProperties = false;
      });
    },
    saveText() {
      this.currentItem.text = this.temporaryText;
      /*
      if (this.currentItem && this.currentItem.styles) {
        if (Object.keys(this.currentItem.styles).length > 0) {
          let totalStyle = Object.keys(
            this.currentItem.styles[
              Object.keys(this.currentItem.styles).length - 1
            ]
          ).length;
          if (totalStyle > 0) {
            if (totalStyle < this.currentItem.text.length) {
              let styleToCopy = this.currentItem.styles[
                Object.keys(this.currentItem.styles).length - 1
              ][
                Object.keys(
                  this.currentItem.styles[
                    Object.keys(this.currentItem.styles).length - 1
                  ]
                ).length - 1
              ];
              this.currentItem.deltaY = styleToCopy.deltaY
                ? styleToCopy.deltaY
                : this.currentItem.deltaY;
              this.currentItem.fill = styleToCopy.fill
                ? styleToCopy.fill
                : this.currentItem.fill;
              this.currentItem.fontFamily = styleToCopy.fontFamily
                ? styleToCopy.fontFamily
                : this.currentItem.fontFamily;
              this.currentItem.fontSize = styleToCopy.fontSize
                ? styleToCopy.fontSize
                : this.currentItem.fontSize;
              this.currentItem.fontStyle = styleToCopy.fontStyle
                ? styleToCopy.fontStyle
                : this.currentItem.fontStyle;
              this.currentItem.fontWeight = styleToCopy.fontWeight
                ? styleToCopy.fontWeight
                : this.currentItem.fontWeight;
              this.currentItem.linethrough = styleToCopy.linethrough
                ? styleToCopy.linethrough
                : this.currentItem.linethrough;
              this.currentItem.overline = styleToCopy.overline
                ? styleToCopy.overline
                : this.currentItem.overline;
              this.currentItem.stroke = styleToCopy.stroke
                ? styleToCopy.stroke
                : this.currentItem.stroke;
              this.currentItem.strokeWidth = styleToCopy.strokeWidth
                ? styleToCopy.strokeWidth
                : this.currentItem.strokeWidth;
              this.currentItem.textBackgroundColor = styleToCopy.textBackgroundColor
                ? styleToCopy.textBackgroundColor
                : this.currentItem.textBackgroundColor;
              this.currentItem.underline = styleToCopy.underline
                ? styleToCopy.underline
                : this.currentItem.underline;
            }
          }
        }
      }*/

      this.loadJSON(this.$refs.canvas.toJson());
    },
    decodeString(str) {
      return  str.replace(/\\xe3/g,"ã").replace(/\\r/g,"\n").replace(/\\xc7/g,"Ç").replace(/\\xc1/g,"Á").replace(/\\xe1/g,"á").replace(/\\xc3/g,"Ã").replace(/\\xea/g,"ê").replace(/\\xca/g,"Ê").replace(/\\xed/g,"í").replace(/\\xcd/g,"Í").replace(/\\xf5/g,"õ").replace(/\\xd5/g,"Õ").replace(/\\xe9/g,"é").replace(/\\xc9/g,"É").replace(/\\xf3/g,"ó").replace(/\\xd3/g,"Ó").replace(/\\xfa/g,"ú").replace(/\\xda/g,"Ú").replace(/\\xe7/g,"ç");      
    },
    loadJSON(json, preventEditOptionsClosing, cb, decodeStrings) {
      if (!this.$refs.canvas) {
        setTimeout(() => {
          this.loadJSON(json, preventEditOptionsClosing, cb);
        }, 70);
        return;
      }

      this.actionList = [];
      var index = 0;
      this.loadingJson = true;
      let jsonBack = undefined;
      let biggest = 0;

      this.actionList = json;
      for (let i = 0; i < this.actionList.objects.length; i++) {
        let templateItem = this.actionList.objects[i];
        if (
          (this.actionList.objects[i] &&
            (this.actionList.objects[i].type &&
              this.actionList.objects[i].type == "i-text")) ||
          this.actionList.objects[i].text
        ) {
          this.actionList.objects[i].id = index;
          if (decodeStrings) {
            this.actionList.objects[i].text = this.decodeString(this.actionList.objects[i].text);
          }
          index++;
          if (this.isMobileScreen) {
            this.actionList.objects[i].editable = false;
          }
        } else if (
          this.actionList.objects[i] &&
          this.actionList.objects[i].type &&
          this.actionList.objects[i].type == "image"
        ) {
          this.imgList.push(this.actionList.objects[i]);
          this.actionList.objects[i].crossOrigin = "anonymous";
          this.actionList.objects[i].filters = [new       fabric.Image.filters.HueRotation()];

          let imgUnique = this.actionList.objects[i].src.split("?");
          if (imgUnique && imgUnique.length > 1 && this.userAddedUniques.indexOf(imgUnique[1]) >= 0) {
            //do not block
          } else {
            this.actionList.objects[i].hasControls = false;
            this.actionList.objects[i].lockRotation = true;
            this.actionList.objects[i].lockMovementX = true;
            this.actionList.objects[i].lockMovementY = true;
            this.actionList.objects[i].evented = false;
          }
        }
        if (
          this.actionList.objects[i].scaleX * this.actionList.objects[i].width >
          biggest
        ) {
          biggest =
            this.actionList.objects[i].scaleX *
            this.actionList.objects[i].width;
          jsonBack = this.actionList.objects[i];
        }
        if (
          this.actionList.objects[i].scaleY *
            this.actionList.objects[i].height >
          biggest
        ) {
          biggest =
            this.actionList.objects[i].scaleY *
            this.actionList.objects[i].height;
          jsonBack = this.actionList.objects[i];
        }
      }

      if (jsonBack && !this.actionList.backgroundImage) {
        /*
        if (this.preventLocking) {
          jsonBack.hasControls = true;
          jsonBack.lockRotation = false;
          jsonBack.lockMovementX = false;
          jsonBack.lockMovementY = false;
        } else {
          jsonBack.hasControls = false;
          jsonBack.lockRotation = true;
          jsonBack.lockMovementX = true;
          jsonBack.lockMovementY = true;
        }
        */
      } else if (this.actionList.backgroundImage) {
        this.actionList.backgroundImage.crossOrigin = "anonymous";
      }

      if (json && json.objects && json.objects.length > 0) {
        this.$refs.canvas.loadFromJSON(json, () => {
          this.loaded = true;
          this.currentItem = undefined;
          this.loadingJson = false;
          this.preventUndo = false;
          if (!preventEditOptionsClosing) {
            this.showImportImage = false;
            this.enableSendToBackground = false;
            this.showSave = false;
            this.showTextEdit = false;
          }
          if (cb) {
            cb();
          }
        });
      } else {
        if (cb) {
          cb();
        }
        this.loadingJson = false;
      }
    },
    startUploadRemoval(item) {
      this.uploadToRemove = item;
      this.showRemoveUploadModal = true;
    },
    uploadAmountError() {
      alert('O limite de uploads é 6. Remova alguns para adicionar novos.');
    },
    updateTemplate() {
      this.disableSaveButton = true;
      let json = this.$refs.canvas.toJson();

      let previewData = this.$refs.canvas.toDataUrl({
        format: "png",
        multiplier: this.finalImageMultiplier
      });

      for (let i = 0; i < json.objects.length; i++) {
        json.objects[i].scaleX *= this.finalMultiplier;
        json.objects[i].scaleY *= this.finalMultiplier;
        json.objects[i].left *= this.finalMultiplier;
        json.objects[i].top *= this.finalMultiplier;
      }

      service
        .updateExpressTemplate(json, previewData, this.story, this.templateId, this.creation)
        .then(result => {
          let updateUrl = "/design/preview/" + this.templateId;

          this.$router.push(updateUrl);
        });
    },
    saveTemplate() {
      this.disableSaveButton = true;
      let json = this.$refs.canvas.toJson();

      let previewData = this.$refs.canvas.toDataUrl({
        format: "png",
        multiplier: this.finalImageMultiplier
      });

      for (let i = 0; i < json.objects.length; i++) {
        json.objects[i].scaleX *= this.finalMultiplier;
        json.objects[i].scaleY *= this.finalMultiplier;
        json.objects[i].left *= this.finalMultiplier;
        json.objects[i].top *= this.finalMultiplier;
      }

      service
        .saveExpressTemplate(json, previewData, this.story, this.templateId, this.creation)
        .then(result => {
          if(result && result.temporaryId) {
            let saveUrl = "/design/save/" + result.temporaryId;

            if (this.isInstagramBrowser) {
              saveUrl += "/instagram1a" + localStorage.sessionId;
            }

            if (this.customSavingUrl) {
              saveUrl = this.customSavingUrl + result.temporaryId;
            }

            this.$router.push(saveUrl);
          } else {
            alert("Erro 9.2. Procure o Suporte.");
            this.disableSaveButton = true;
          }          
        }).catch((error) => {
          console.log(error);
          try {
            alert("Erro 9.3. Procure o Suporte e mostre a mensagem: " + JSON.stringify(error));
            service.reportError(JSON.stringify(error))
          } catch {
            alert("Erro 9.1. Procure o Suporte.");
          }
          this.disableSaveButton = true;
        });
    },
    handleAdd(url) {
      this.loadingAttachment = true;
      let imgUnique = Math.random() + "";
      this.userAddedUniques += "?"+imgUnique;
      
      let result = this.$refs.canvas.createImage(url + "?" + imgUnique);

      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas.toJson())); //deepCopy

      this.lastJson.push(copyItem);
    },
    handleAddElement(url) {
      this.hideElements();
      this.handleAdd(url);
    },
    addText() {
      this.$refs.canvas.createText("Novo Texto", {
        left: 100,
        top: 100,
        fontSize: 40,
        fill: "#000000",
        lineHeight: 0.8
      });

      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas.toJson())); //deepCopy
      this.lastJson.push(copyItem);
    },
    handleDelete() {
      this.showTextEdit = false;
      this.$refs.canvas.removeCurrentObj();
    },
    rotate() {
      this.$refs.canvas.setRotate();
    },
    clearedSelection() {
      this.showTextEdit = false;
      this.enableSendToBackground = false;
      this.currentItem = null;
      this.showImportImage = true;
      this.showSave = true;
      this.showTrash = false;
      this.showImportImage = false;
    },
    selected(obj, option) {
      this.showTrash = false;
      if (isMobile == true) {
        if (obj && obj.target) {
          if (
            (obj.target.type && obj.target.type == "i-text") ||
            obj.target.text
          ) {
            this.currentItem = obj.target;
            this.showTextEdit = true;
            this.temporaryText = obj.target.text;
            this.showImportImage = false;
            this.enableSendToBackground = false;
            this.showSave = false;
            this.textToEdit = obj.target.text;
          }
          if (
            obj.target.type &&
            obj.target.type == "image" &&
            obj.target.hasControls
          ) {
            this.currentItem = obj.target;
            this.showTextEdit = false;
            this.showImportImage = false;
            this.enableSendToBackground = true;
            this.showSave = false;
            this.showTrash = true;
          }
        }
      } else {
        this.showTextEdit = false;
        this.enableSendToBackground = false;
        this.currentItem = null;
        if (obj && obj.target) {
          if (
            (obj.target.type && obj.target.type == "i-text") ||
            obj.target.text
          ) {
            this.showTextEdit = true;
            this.currentItem = obj.target;
          } else if (
            obj.target.type &&
            obj.target.type == "image" &&
            obj.target.hasControls
          ) {
            this.enableSendToBackground = true;
            this.currentItem = obj.target;
          }
        }
      } 
    },
    moving(obj, option) {
      if (obj.target.id == "bg") {
        obj.target.top = this.heightAndWidth.height / 2;
        obj.target.left = this.heightAndWidth.width / 2;
      }
    },
    modified(obj, option) {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas.toJson())); //deepCopy
      this.lastJson.push(copyItem);
    },
    undoAction() {
      if (this.lastJson.length > 1) {
        let historySize = this.lastJson.length;
        let jsonToLoad = this.lastJson.pop();
        //this.lastJson = this.lastJson.splice(- 1, 1);
        historySize = this.lastJson.length;
        this.preventUndo = true;
        if (this.advancedEdition == true) {
          this.loadJSON(jsonToLoad);
        } else {
          this.preventUndo = true;
          this.reload(true);
        }
        return;
      }
      this.preventUndo = true;
      this.reload(true);
    },
    onFileInputChanged(event) {
      this.uploadFiles(event.target.files);
    },
    trigger() {
      this.$refs.fileInput.click();
    },
    attachmentLoaded() {
      this.loadingAttachment = false;
    },
    uploadFiles(files) {
      this.loading = true;

      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );

      reader.readAsDataURL(files[0]);
      this.loading = true;

      var formData = new FormData();
      formData.append("file", files[0]);

      const baseURL = Config.BASE_API_URL;

      var vm = this;
      fetch(baseURL + "upload-file", {
        headers: {
          "Conectados-Auth": localStorage.sessionId
        },
        method: "POST",
        body: formData,
        bypassInterceptor: true
      }).then(function(response) {
        if (response && response.status && response.status === 200) {
          vm.$emit("uploadComplete");
          vm.imagePreview = "";
          vm.loading = false;
        } else {
          alert("Houve um problema com seu upload :( Tente novamente mais tarde");
          vm.loading = false;
        }
      });
    },
    calculateScale() {
      var jsonCopyItem = { objects: [] };

      var jsonBack = {};

      let biggest = 0;

      var jsonObjectsCopy = JSON.parse(JSON.stringify(this.jsonObject));

      for (var i = 0; i < jsonObjectsCopy.length; i++) {
        jsonObjectsCopy[i].scaleX = jsonObjectsCopy[i].scaleX / this.initialMultiplier;
        jsonObjectsCopy[i].scaleY = jsonObjectsCopy[i].scaleY / this.initialMultiplier;
        jsonObjectsCopy[i].left = jsonObjectsCopy[i].left / this.initialMultiplier;
        jsonObjectsCopy[i].top = jsonObjectsCopy[i].top / this.initialMultiplier;

        jsonCopyItem.objects.push(jsonObjectsCopy[i]);
      }

      if (this.backgroundColor) {
        jsonCopyItem.background = this.backgroundColor;
      }

      return jsonCopyItem;
    }
  }
};
</script>


<style>
  .margin-mobile {
    margin-left: 20%;
  }
</style>